import { faker } from '@faker-js/faker';

import type { Address } from '~/api/types';

export const AddressFactory = (): Address =>
  ({
    mainLine: faker.location.streetAddress(),
    secondaryLine: faker.location.secondaryAddress(),
    zipCode: faker.location.zipCode(),
    country: faker.helpers.arrayElement(['US', 'NZ']),
    state: faker.location.state(),
    city: faker.location.city(),
  }) satisfies Address;
